import { defineComponent as _defineComponent } from 'vue'
import useSnackbar from '~/composables/useSnackbar'

export default /*#__PURE__*/_defineComponent({
  __name: 'SnackbarContainer',
  setup(__props) {

const { snackbars, hideSnackbar } = useSnackbar()

return { __sfc: true,snackbars, hideSnackbar }
}

})